import { useEffect, useState } from 'react'

import { useErrorHandler } from '../../hooks/useErrorHandler'
import { apiClient } from '../../modules/apiclient'
import { Spinner } from '../Spinner'
import Modal from '../app/design/Modal'

type Props = {
    isOpen: boolean
    onClose: () => void
    endpoint: { path: string; body?: Record<string, any> } | undefined
}

export const PDFPreviewModal = ({ isOpen, onClose, endpoint }: Props) => {
    const { logAndDisplayError } = useErrorHandler()

    const [pdfData, setPDFData] = useState<string | undefined>(undefined)

    useEffect(() => {
        if (!isOpen || endpoint === undefined) return
        ;(async () => {
            try {
                const resp = await apiClient.post(endpoint.path, endpoint.body, {
                    responseType: 'arraybuffer',
                })
                const base64 = btoa(
                    new Uint8Array(resp.data).reduce(
                        (data, byte) => data + String.fromCharCode(byte),
                        ''
                    )
                )
                setPDFData(`data:application/pdf;base64,${base64}`)
            }
            catch (error) {
                logAndDisplayError(error)
                onClose()
            }
        })()
    }, [endpoint])

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Preview" width={828}>
            {!isOpen || pdfData === undefined ? (
                <div className="flex items-center justify-center">
                    <Spinner size={64} />
                </div>
            ) : (
                <div className="flex h-[1056px] max-h-full w-[816px] max-w-full items-center justify-center">
                    <iframe src={pdfData} title="Preview" className="h-full w-full" />
                </div>
            )}
        </Modal>
    )
}
